import React from 'react';

interface StarRatingProps {
  rating: number;
  isBestSeller?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, isBestSeller }) => {
  const totalStars = 5;

  return (
    <div className="flex gap-1 mt-2 mb-6 items-center">
      {Array.from({ length: totalStars }).map((_, index) => (
        <svg
          key={index}
          className="h-5 w-auto fill-current text-yellow-500"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.3l2.388 7.49H20l-6.194 4.51L15.622 21 10 16.59 4.377 21l1.813-7.7L0 8.79h7.611z" />
        </svg>
      ))}
      <span className="font-semibold ml-1">{rating.toFixed(1)}</span>
      {isBestSeller && (
        <span className="text-[14px] mt-0.5 ml-1">Best Seller</span>
      )}
    </div>
  );
};

export default StarRating;
